module.exports = __webpack_public_path__ + "img/sign_us.fbd83b2d.png";